/**
 * Class strings for segmented controls: one track, equal pill items, the selected one raised.
 * Shared by the layout switch (List / Board / Timeline), the inbox filter, the display options
 * (Segmented) and the login language switch, so every segmented control looks and sizes alike.
 *
 *   <nav className={segmentTrack}>
 *     <Link className={cx(segmentItem, current && segmentItemActive)} aria-current=...>List</Link>
 *   </nav>
 *
 * React Aria ToggleButtons use `segmentItemSelected` (data-selected) instead of `segmentItemActive`.
 */
export const segmentTrack = "flex items-center gap-0.5 rounded-control bg-segment-track p-0.5";

export const segmentItem =
  "press transition-ui inline-flex h-(--control-h-sm) min-w-0 items-center justify-center gap-1.5 rounded-mark " +
  "px-2.5 text-xs font-medium text-fg-muted hover:text-fg data-hovered:text-fg";

export const segmentItemActive = "bg-segment-active text-fg shadow-(--segment-active-shadow)";

export const segmentItemSelected =
  "data-selected:bg-segment-active data-selected:text-fg data-selected:shadow-(--segment-active-shadow)";
